import { useState } from 'react';
import { Switch } from '@tempmee/react';
import { Pressable, Text } from '../../../../../commonComponents';
import { Colors } from '../../../../../themes/colors';
import { GuidelinesPopup } from './GuidelinesPopup';

export const GuideLinesSwitch = ({ onSwitch, hasError }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const handleSwitch = () => {
    setAcceptedTerms(!acceptedTerms);
    onSwitch(!acceptedTerms);
  };

  const label = (
    <Text>
      I agree to{' '}
      <Pressable onPress={() => setShowPopup(true)}>
        <Text bold color={Colors.secondary_500}>
          GoTu’s Shift Guidelines
        </Text>
      </Pressable>
      .
    </Text>
  );

  return (
    <div
      style={{ display: 'flex', justifyContent: 'center', marginBottom: 40 }}
      data-testid="guidelines-agreement-toggle"
      data-cy="guidelines-agreement-toggle"
    >
      <Switch
        data-testid="guidelines-toggle-switch"
        data-cy="guidelines-toggle-switch"
        checked={acceptedTerms}
        onChange={handleSwitch}
        label={label}
        error={hasError}
      />
      {showPopup && <GuidelinesPopup onClose={() => setShowPopup(false)} />}
    </div>
  );
};
